"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));

var _isUndefined2 = _interopRequireDefault(require("lodash/isUndefined"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Link = _interopRequireDefault(require("../Typography/Link"));

var _PopupProvider = _interopRequireDefault(require("../Utility/PopupProvider"));

var _ThemeManager = _interopRequireDefault(require("../../../managers/ThemeManager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * Dropdown with customizable menu.
 */
var Dropdown =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Dropdown, _React$Component);

  function Dropdown() {
    var _this;

    _classCallCheck(this, Dropdown);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Dropdown).call(this)); // State used when uncontrolled

    _this.state = {
      popupVisible: false
    };
    _this.handlePopupContentOnClick = _this.handlePopupContentOnClick.bind(_assertThisInitialized(_this));
    _this.handlePopupVisibleChange = _this.handlePopupVisibleChange.bind(_assertThisInitialized(_this));
    return _this;
  }
  /**
   * Automatically offset in certain conditions
   * @returns {object} offset
   */


  _createClass(Dropdown, [{
    key: "autoOffset",
    value: function autoOffset() {
      var _this$props = this.props,
          children = _this$props.children,
          popupPlacement = _this$props.popupPlacement;
      var offset = {}; // For links, offset dropdown to make the carets align between popup and link

      if (typeof children === 'string' && popupPlacement === 'auto') {
        offset.x = '15px'; // Distance from dropdwn caret to edge of child caret
      }

      return offset;
    }
    /**
     * Handler to fire when popup content is clicked. Will hide dropdown.
     */

  }, {
    key: "handlePopupContentOnClick",
    value: function handlePopupContentOnClick() {
      if (this.isPopupUncontrolled()) {
        this.setState({
          popupVisible: false
        });
      }
    }
    /**
     * Handler when fired will set internal visible state for dropdown.
     * @param {boolean} visible - visible state to set popup for dropown
     */

  }, {
    key: "handlePopupVisibleChange",
    value: function handlePopupVisibleChange(visible) {
      this.setState({
        popupVisible: visible
      });
    }
    /**
     * Used to detect when to use internal state to manage the popup visibility
     * @returns {boolean} true if popup is uncontrolled
     */

  }, {
    key: "isPopupUncontrolled",
    value: function isPopupUncontrolled() {
      return (0, _isUndefined2.default)(this.props.popupVisible);
    }
    /**
     * Get popup placement
     * @param {object} children - children element
     * @param {string} popupPlacement - popup placement
     * @returns {string} placement
     */

  }, {
    key: "getPopupPlacement",
    value: function getPopupPlacement(children, popupPlacement) {
      var placement;

      if (popupPlacement !== 'auto') {
        placement = popupPlacement; // Link placement (string)
      } else if (typeof children === 'string' && popupPlacement === 'auto') {
        placement = 'bottomRight'; // Default (element)
      } else {
        placement = 'bottom';
      }

      return placement;
    }
    /**
     * Maps offset x/y to style props
     * @param {string} popupOffset - offset x/y values
     * @returns {object} styleOffset
     */

  }, {
    key: "getStyleOffset",
    value: function getStyleOffset(popupOffset) {
      var styleOffset = {
        position: 'relative'
      };

      if (!(0, _isEmpty2.default)(popupOffset)) {
        styleOffset.top = popupOffset && popupOffset.y;
        styleOffset.left = popupOffset && popupOffset.x; // Auto offset
      } else {
        var offset = this.autoOffset();
        styleOffset.top = offset.y;
        styleOffset.left = offset.x;
      }

      return styleOffset;
    }
    /**
     * Wraps children element in a Link if it is a string or pass through if not
     * @param {object} children - children element
     * @param {boolean} disabled - disable the child element
     * @returns {node} children element
     */

  }, {
    key: "renderChildrenNode",
    value: function renderChildrenNode(children, disabled) {
      if (typeof children === 'string') {
        return _react.default.createElement(_Link.default, {
          disabled: disabled,
          type: "expandable"
        }, children);
      } // Clone the child element and pass through the disabled prop


      if (disabled) {
        return _react.default.cloneElement(children, {
          disabled: disabled
        });
      }

      return children;
    }
    /**
     * Wraps popup in a styled container
     * @param {boolean} wrapComponent - true to wrap component
     * @param {ReactElement} popup - popup element
     * @param {object} [popupOffset] - x/y coordinates to offset
     * @returns {node} children element
     */

  }, {
    key: "renderPopupWrapper",
    value: function renderPopupWrapper(wrapComponent, popup, popupOffset) {
      var popupWrapper;

      if (wrapComponent) {
        popupWrapper = _react.default.createElement("div", {
          className: "popup-wrapper",
          style: this.getStyleOffset(popupOffset)
        }, _react.default.createElement("div", {
          className: "popup-content",
          onClick: this.handlePopupContentOnClick
        }, popup), _react.default.createElement("div", {
          className: "popup-arrow"
        }));
      } else {
        popupWrapper = popup;
      }

      return popupWrapper;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          disabled = _this$props2.disabled,
          popup = _this$props2.popup,
          popupClassName = _this$props2.popupClassName,
          popupOffset = _this$props2.popupOffset,
          popupPlacement = _this$props2.popupPlacement,
          popupVisible = _this$props2.popupVisible,
          wrapComponent = _this$props2.wrapComponent,
          props = _objectWithoutProperties(_this$props2, ["children", "disabled", "popup", "popupClassName", "popupOffset", "popupPlacement", "popupVisible", "wrapComponent"]);

      var childNode = this.renderChildrenNode(children, disabled); // Render the childNode directly when disabled. No need to wrap it.

      if (disabled) {
        return childNode;
      } // Determined on the basis when the application takes control of popup visible state.


      var controllableProps = {};

      if (this.isPopupUncontrolled()) {
        controllableProps.popupVisible = this.state.popupVisible;
        controllableProps.onPopupVisibleChange = this.handlePopupVisibleChange;
      } else {
        controllableProps.popupVisible = popupVisible;
      }

      return _react.default.createElement(_PopupProvider.default, _extends({
        popup: this.renderPopupWrapper(wrapComponent, popup, popupOffset),
        popupClassName: (0, _classnames.default)(popupClassName, "".concat(_ThemeManager.default.getVar('classPrefix'), "-dropdown")),
        popupPlacement: this.getPopupPlacement(children, popupPlacement),
        prebuiltPlacementMap: "offset10px",
        transitionType: "slide"
      }, controllableProps, props), childNode);
    }
  }]);

  return Dropdown;
}(_react.default.Component);

exports.default = Dropdown;
Dropdown.defaultProps = {
  action: 'click',
  popupPlacement: 'auto',
  wrapComponent: true
};
Dropdown.propTypes = {
  /**
   * Event to trigger dropdown.
   */
  action: _propTypes.default.oneOf(['hover', 'click', 'focus', 'contextMenu']),

  /**
   * This is the component/text of the dropdown where the user can hover or click on. By default
   * if `text` is set then the `Link` component will be used to wrap the text. For other component
   * types, beware of handling the `disabled` property. See `disabled` prop for details.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * This disables the Dropdown component and will also pass down 'disabled' prop to child node.
   * Note: When used it is expected the child node knows how to respond to this
   * property accordingly.
   */
  disabled: _propTypes.default.bool,

  /**
   * Container to place popup in. Use when popup will scroll with content from a source other
   * than the body. e.g. `() => document.querySelector('.modal')`
   */
  getPopupContainer: _propTypes.default.func,

  /**
   * Called when popup visibility changes.
   * @param {boolean} visible
   */
  onPopupVisibleChange: _propTypes.default.func,

  /**
   * Typically this should be `<Menu>` but it can be a customized component.
   */
  popup: _propTypes.default.element.isRequired,

  /**
   * Customize additional class name for popup.
   */
  popupClassName: _propTypes.default.string,

  /**
   * Set offset position for popup. String values can be of any measurement type. e.g. px, vh, em
   */
  popupOffset: _propTypes.default.shape({
    x: _propTypes.default.string,
    y: _propTypes.default.string
  }),

  /**
   * Set placement position of dropdown over children.
   */
  popupPlacement: _propTypes.default.oneOf(['auto', 'leftTop', 'left', 'leftBottom', 'topLeft', 'top', 'topRight', 'rightTop', 'right', 'rightBottom', 'bottomLeft', 'bottom', 'bottomRight']),

  /**
   * Set visibility of popup. Note: This will override and ignore state of the 'action' prop.
   */
  popupVisible: _propTypes.default.bool,

  /**
   * Wrap `popup` inside the styled dropdown container. Note: When set to false, the styled
   * dropdown container will not be used and the dropdown automatic event handling for popup
   * visibility will cease function.
   */
  wrapComponent: _propTypes.default.bool
};